export default {
  MINUTES: "minutes",
  HOUR: "hour",
  DAY: "day",
  DAY_UPPER: "DAY",
};
